import { z } from 'zod';

import { firstPasswordRuleError } from '@/lib/auth/password-rules';

/** Valeurs du formulaire « Nouveau mot de passe ». */
export interface NouveauMdpValues {
    email: string;
    password: string;
    password_confirmation: string;
}

const REQUIRED_FIELDS = ['email', 'password', 'password_confirmation'] as const;

export const nouveauMdpSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Record<string, unknown>;
    const errors: Record<string, string> = {};

    for (const field of REQUIRED_FIELDS) {
        if (!v[field]) errors[field] = 'Le champ est obligatoire';
    }

    if (v['password'] && v['password_confirmation'] && v['password'] !== v['password_confirmation']) {
        errors['password'] = "la confirmation du mot de passe n'est pas valide";
        errors['password_confirmation'] = "la confirmation du mot de passe n'est pas valide";
    }

    // Mêmes règles que PASS, pour ne pas refuser côté serveur un mot de passe que le
    // formulaire vient d'accepter. Le hotfix « & » (encodage Gravitee AM) en fait partie.
    if (v['password']) {
        const ruleError = firstPasswordRuleError(String(v['password']));

        if (ruleError) {
            errors['password'] = ruleError;
        }
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
